<template>
    <div class="buildingCardContainer-row-column buildingCardContainer-badgeMenu" v-if="buildingId && user">
        <a href="javascript:void(0)" class="badge btn-outline-success dropdown-toggle buildingCardContainer-badgeMenu-btn" v-on:click="toggle(buildingId)"><i class="fas fa-bell mr-1" data-toggle="tooltip" data-placement="bottom" title="Setup Notification"></i> Notification</a>

        <div class="card buildingCardContainer-badgeMenu-menu" v-bind:class="{'d-none':notifications.invisible}">
            <div class="triangle"></div>
            <form v-on:submit.prevent>
                <div class="card-body">
                    <div class="card-text clearfix" v-if="userNotifications.list.length">
                        <label class="d-block buildingCard-checkbox"
                               v-for="(userNotification, index) in userNotifications.list"
                               v-bind:key="userNotification.notification_id"
                        >
                            <input class="buildingCard-checkbox-input"
                                   type="checkbox"
                                   v-on:change="updateUserNotifications(buildingId, userNotification)"
                                   v-bind:name="'notification-' + userNotification.notification_id"
                                   v-bind:value="userNotification.id"
                                   v-model="userNotification.opt_in"/>
                            <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': !userNotification.opt_in}"></i></span>
                            {{userNotification.desc}}
                            <span v-if="userNotifications.saving.indexOf(userNotification.notification_id) > -1" class="spinner-border spinner-border-sm text-danger" role="status">
                                <span class="sr-only">saving...</span>
                            </span>
                            <i v-if="userNotifications.saved.indexOf(userNotification.notification_id) > -1"  class="far fa-check-circle text-success"></i>
                        </label>
                    </div>
                    <div class="text-center" v-if="notifications.loading || userNotifications.loading">
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <hr>
                    <div class="card-text clearfix">
                        Notification will be sent to: {{user.email}}.
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  import Tools from '@/app-model/tools.js';
  import Notification from '@/app-model/notification.js';

  export default {
    props: {
      buildingId: Number|String
    },
    data () {
      return {
        notifications: {
          invisible: true,
          loading: false,
          buildingId: undefined,
          selectedValue: [],
          list: []
        },
        userNotifications: {
          loading: false,
          saving: [],
          buildingId: undefined,
          saved: [],
          list: []
        }
      }
    },
    mounted() {
      let {b: buildingId, notification} = this.tools.getDataFromUrlHash({ notification: {visible: false}}, ['b', 'notification']);

      if(buildingId === this.buildingId && notification.visible) {
        this.toggle(this.buildingId);
      }
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      user: function() {
        return this.$store.getters.firebaseUser;
      },
      notification: function () {
        return new Notification();
      }
    },
    methods: {
      toggle: async function (buildingId) {
        this.notifications.invisible = !this.notifications.invisible;
        this.loadNotifications(buildingId)
          .then(() => this.loadUserNotifications(buildingId));
      },
      loadNotifications: function (buildingId) {
        if(buildingId !== this.notifications.buildingId) {
          this.notifications.loading = true;
          return this.notification.loadNotifications(this.$store, buildingId)
            .then(response => {
              if (response.status === 200 && buildingId === this.buildingId) {
                this.notifications.buildingId = buildingId;
                this.$set(this.notifications, 'list', response.data.data);
              }
              this.notifications.loading = false;
            });
        }
        return new Promise((resolve, reject) => {
          resolve();
        });
      },
      loadUserNotifications: function (buildingId) {
        if(buildingId !== this.userNotifications.buildingId) {
          this.userNotifications.loading = true;
          return this.notification.loadUserNotifications(this.$store, buildingId)
            .then(response => {
              if (response.status === 200 && buildingId === this.buildingId) {
                this.userNotifications.buildingId = buildingId;

                let data = [];
                for(let i = 0; i < this.notifications.list.length; i++) {
                  let {id: notification_id, default_opt_in: opt_in, desc} = this.notifications.list[i],
                    index = response.data.data.findIndex(el => el.notification_id === notification_id),
                    notification = {};
                  if(index < 0) {
                    notification = {notification_id, opt_in};
                  }
                  else {
                    notification = Object.assign({},response.data.data[index]);
                  }

                  data.push(Object.assign({}, notification, {desc}));
                }

                this.$set(this.userNotifications, 'list', data);
              }
              this.userNotifications.loading = false;
            });
        }
        return new Promise((resolve, reject) => {
          resolve();
        });
      },
      updateUserNotifications: function (buildingId, userNotification) {
        let method = userNotification.opt_in ? 'PUT' : 'DELETE',
          notificationId = userNotification.notification_id,
          top = this;
        this.userNotifications.saved = this.userNotifications.saved.filter(el => el !== notificationId);
        this.userNotifications.saving.push(notificationId);
        this.notification.updateUserNotifications(this.$store, method, buildingId, notificationId)
          .then(response => {
            this.userNotifications.saving = this.userNotifications.saving.filter(el => el !== notificationId);
            if (response.status === 200 && buildingId === this.buildingId) {
              this.userNotifications.saved.push(notificationId);
            }
            setTimeout(function () {
              top.userNotifications.saved = top.userNotifications.saved.filter(el => el !== notificationId);
            }, 1000);
          });
      }
    }
  }
</script>

<style scoped>

</style>